import { message, Tooltip } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Card, Form, FormGroup, Input, Modal, ModalBody, Spinner } from "reactstrap";
import { AllowAccess } from "../../../components/BlockAccess";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
  ProductTable,
  RSelect,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { computationFormula, interestFormula, statusOptions } from "../options_common";

// const { Option } = Select;

// const children = [];

// for (let i = 10; i < 36; i++) {
//   children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
// }

export const ProductManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    productName: "",
    productCode: "",
    allowCustomization: false,
    productCategory: 0,
    maxTransactionLimit: 0,
    minTransactionLimit: 0,
    productDescription: "",
    imageUrl: "",
  });
  const [properties, setProperties] = useState({
    acceptsRollover: false,
    hasDirectDebit: false,
    allowsLiquidation: false,
    allowsMonthlyDraw: false,
    allowsTopUp: false,
    allowsTransfer: false,
    hasContributionValue: false,
    receivesTransfer: false,
    hasSavingFrequency: false,
    hasTargetAmount: false,
  });
  const [, setTargetAmount] = useState(false);
  const [, setSavingFrequency] = useState(false);
  const [interestOption, setInterestOption] = useState({
    hasBackendBiAnnualInterestRate: false,
    hasBackendMaturityRate: false,
    hasBackendMonthlyInterestRate: false,
    hasBackendQuarterlyInterestRate: false,
    hasBackendUpfrontInterestRate: false,
    hasBiAnnualInterestRate: false,
    hasMaturityRate: false,
    hasMonthlyInterestRate: false,
    hasQuarterlyInterestRate: false,
    hasUpfrontInterestRate: false,
  });
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllProducts();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  function encodeImageFileAsURL(event) {
    var file = event.target.files[0];
    var reader = new FileReader();
    reader.onloadend = function () {
      const res = reader.result;
      if (res) {
        const imgArr = res.split("base64,");
        let url = imgArr[1];
        setFormData({ ...formData, imageUrl: url });
      }
    };
    reader.readAsDataURL(file);
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [product, setProduct] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [, setAllowSubmit] = useState(false);
  const [details, setDetails] = useState();
  const [currencies, setCurrencies] = useState([]);
  const [productCat, setProductCat] = useState();
  const [tenors, setTenors] = useState([]);

  // OnChange function to get the input data
  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (e, name) => {
    const { value } = e;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePropertyCheckBox = (e) => {
    const { name, checked } = e.target;
    setProperties({ ...properties, [name]: checked });
  };

  const handleInterestOptions = (e) => {
    const { name, checked } = e.target;
    setInterestOption({ ...interestOption, [name]: checked });
  };

  const getAllCurrencies = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trcurrency`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      const filteredCurrencies = resultData.filter((data) => data.status === "ACTIVE");
      if (resultData) {
        setCurrencies(filteredCurrencies);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getTenors = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trtenor`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      const filteredTenors = resultData.filter((data) => data.tenorStatus === "ACTIVE");
      if (resultData) {
        setTenors(filteredTenors);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      productName: "",
      productCode: "",
      allowCustomization: false,
      productCategory: 0,
      maxTransactionLimit: 0,
      minTransactionLimit: 0,
      productDescription: "",
      imageUrl: "",
    });
    setProperties({
      acceptsRollover: false,
      hasDirectDebit: false,
      allowsLiquidation: false,
      allowsMonthlyDraw: false,
      allowsTopUp: false,
      allowsTransfer: false,
      hasContributionValue: false,
      receivesTransfer: false,
      hasSavingFrequency: false,
      hasTargetAmount: false,
    });
    setTargetAmount(false);
    setSavingFrequency(false);
    setInterestOption({
      hasBackendBiAnnualInterestRate: false,
      hasBackendMaturityRate: false,
      hasBackendMonthlyInterestRate: false,
      hasBackendQuarterlyInterestRate: false,
      hasBackendUpfrontInterestRate: false,
      hasBiAnnualInterestRate: false,
      hasMaturityRate: false,
      hasMonthlyInterestRate: false,
      hasQuarterlyInterestRate: false,
      hasUpfrontInterestRate: false,
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const getAllProducts = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trproduct?search=${search}`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setProduct(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllProductCategories = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trproduct-category`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      const filteredCategories = resultData.filter((data) => data.status === "ACTIVE");
      if (resultData) {
        setProductCat(filteredCategories);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      // const message = error.response;
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const createProduct = async () => {
    const data = {
      ...formData,
      currency: formData?.currency?.map((curr) => curr.value),
      tenors: formData?.tenors?.map((tenor) => tenor.value),
      properties: {
        ...properties,
        interestOption,
      },
    };
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/trproduct`, data, {
        headers: authHeader(),
      });
      if (response) {
        getAllProducts();
      }
      message.success({
        content: "Product Created Successfully",
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
    } catch (error) {
      toast.error(error.response.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setIsLoadBtn(false);
      setModal({ add: false });
      setIsLoading(false);
    }
  };

  const editProduct = async () => {
    const data = {
      ...formData,
      currency: formData?.currency?.map((curr) => curr.value),
      tenors: formData?.tenors?.map((tenor) => tenor.value),
      properties: {
        ...properties,
        interestOption,
      },
    };
    try {
      setIsLoading(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/trproduct/${editId}`, data, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllProducts();
        message.success({
          content: "Product Edited Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        setIsLoadBtn(false);
        setIsLoading(false);
        resetForm();
      }

      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      resetForm();
      message.error({
        content: error.response.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onFormSubmit = () => {
    if (
      formData.status &&
      formData.tenors &&
      formData.currency &&
      properties?.interestFormula &&
      properties?.penaltyFormula
    ) {
      if (
        interestOption.hasBackendBiAnnualInterestRate === true ||
        interestOption.hasBackendMaturityRate === true ||
        interestOption.hasBackendMonthlyInterestRate === true ||
        interestOption.hasBackhasBackendQuarterlyInterestRateendMaturityRate === true ||
        interestOption.hasBackendUpfrontInterestRate === true ||
        interestOption.hasBiAnnualInterestRate === true ||
        interestOption.hasMaturityRate === true ||
        interestOption.hasMonthlyInterestRate === true ||
        interestOption.hasQuarterlyInterestRate === true ||
        interestOption.hasUpfrontInterestRate === true
      ) {
        createProduct();
      } else {
        toast.error("Please Select at least one Interest Option", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error(
        "Please Make Sure You've Selected the Status, Tenors, Currency, Interest Formular and Penalty Formular",
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
    }
  };

  const onEditSubmit = () => {
    editProduct();
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    const setcurrencies = items.currency;
    const currencyArr = setcurrencies.map((currency) => ({
      label: currency.name,
      value: currency.id,
    }));
    const settenors = items.tenors;
    const tenorArr = settenors.map((tenor) => ({
      label: tenor.tenorName,
      value: tenor.id,
    }));

    setFormData({
      productName: items.productName,
      productCode: items.productCode,
      allowCustomization: items.allowCustomization,
      productCategory: items.productCategory.id,
      maxTransactionLimit: items.maxTransactionLimit,
      minTransactionLimit: items.minTransactionLimit,
      status: items.status,
      productDescription: items.productDescription,
      imageUrl: items.imageUrl,
      currency: currencyArr,
      tenors: tenorArr,
      tenorDisplayIn: items.tenorDisplayIn,
    });
    setProperties(items.properties);
    setInterestOption(items.properties?.interestOptions);
    setEditedId(items.id);
  };

  const onViewClick = async (items) => {
    setModal({ view: true });
    setDetails(items);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = product.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllCurrencies();
    getTenors();
    getAllProductCategories();
    getAllProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const productCategoryOptions =
    productCat?.map((cat) => ({
      label: cat.name,
      value: cat.id,
    })) ?? [];

  const tenorOptions =
    tenors?.map((tenor) => ({
      label: tenor.tenorName,
      value: tenor.id,
    })) ?? [];
  const currencyOptions =
    currencies?.map((currency) => ({
      label: currency.name,
      value: currency.id,
    })) ?? [];

  const handleMultiSelect = (e, name) => {
    setFormData({ ...formData, [name]: e });
  };

  return (
    <React.Fragment>
      <Head title="Product Management" />
      <Content>
        <Block>
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Product</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Product..."
                    />
                  </div>{" "}
                  <AllowAccess allowedRights={["CREATE_PRODUCT"]}>
                    <Button onClick={() => setModal({ add: true })} color="primary">
                      <Icon name="plus" />
                      <span>Add Product</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ProductTable product={currentItems} modal={modal} onEditClick={onEditClick} handleView={onViewClick} />
            )}
          </Card>
          <div className="card-inner">
            {!isLoading && product && product.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={product.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Product found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Product</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Product Name</label>
                      <input
                        type="text"
                        name="productName"
                        placeholder="Product Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.productName && <span className="invalid">{errors.productName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Abbreviation</label>
                      <input
                        type="text"
                        name="productCode"
                        placeholder="Abbreviation"
                        onChange={(e) => onInputChange(e)}
                        maxLength="6"
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.productCode && <span className="invalid">{errors.productCode.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Category</label>
                      <RSelect
                        onChange={(e) => handleSelectChange(e, "productCategory")}
                        placeholder="Please Select A Category"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                        options={productCategoryOptions}
                      />
                      {errors.productCategory && <span className="invalid">{errors.productCategory.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Minimum Transaction Limit</label>
                      <input
                        type="text"
                        name="minTransactionLimit"
                        placeholder="0.00"
                        onChange={(e) => setFormData({ ...formData, minTransactionLimit: parseInt(e.target.value) })}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.minTransactionLimit && (
                        <span className="invalid">{errors.minTransactionLimit.message}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Maximum Transaction Limit</label>
                      <input
                        type="number"
                        name="maxTransactionLimit"
                        placeholder="0.00"
                        onChange={(e) => setFormData({ ...formData, maxTransactionLimit: parseInt(e.target.value) })}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.maxTransactionLimit && (
                        <span className="invalid">{errors.maxTransactionLimit.message}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        name="status"
                        options={statusOptions}
                        onChange={(e) => handleSelectChange(e, "status")}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Product Description</label>
                      <textarea
                        name="productDescription"
                        placeholder="Your description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.productDescription && (
                        <span className="invalid">{errors.productDescription.message}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Image</label>
                      <input
                        type="file"
                        name="imageUrl"
                        accept="image/*"
                        placeholder="Product Image"
                        className="form-control"
                        onChange={(e) => encodeImageFileAsURL(e)}
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Tenor</label>
                      <RSelect
                        options={tenorOptions}
                        placeholder="Select Tenors"
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(e) => {
                          handleMultiSelect(e, "tenors");
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <Input
                        name="allowCustomization"
                        type="checkbox"
                        onChange={(e) => setFormData({ ...formData, allowCustomization: e.target.checked })}
                      />
                      <label className="form-label">Allow Tenor Customization</label>
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Currencies</label>
                      <RSelect
                        options={currencyOptions}
                        placeholder="Select Currencies"
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(e) => handleMultiSelect(e, "currency")}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <h6>Choose Properties</h6>
                  </Col>

                  <>
                    <Col md="4">
                      <Tooltip title="Selection of this will display the target amount field in the plan creation page of the customer portal.">
                        <FormGroup>
                          <Input name="hasTargetAmount" type="checkbox" onChange={(e) => handlePropertyCheckBox(e)} />
                          <label className="form-label">Has Target Amount</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="4">
                      <Tooltip title="Selection of this will display the following Frequency options Daily, Weekly, and Monthly to be available for selection during plan creation via the customer portal/admin portal and also display the savings frequency contribution value field and the checkbox to accept contribution value in the plan creation page of the customer portal.">
                        <FormGroup>
                          <Input
                            name="hasSavingFrequency"
                            type="checkbox"
                            onChange={(e) => handlePropertyCheckBox(e)}
                          />
                          <label className="form-label">Has Savings Frequency</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection of this enables the options (Yes/No) to be available for selection during plan creation via the customer portal/admin portal for the user creating a plan to set up the direct mandate. ">
                        <FormGroup>
                          <Input name="hasDirectDebit" onChange={(e) => handlePropertyCheckBox(e)} type="checkbox" />
                          <label className="form-label">Has Direct Debit</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection of this enables the “number of tickets'' to display in the plan creation page of the customer portal.">
                        <FormGroup>
                          <Input name="allowsMonthlyDraw" onChange={(e) => handlePropertyCheckBox(e)} type="checkbox" />
                          <label className="form-label">Allows Monthly Draw</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection of this enables the options (Yes/No)  for users to set up the “Auto Renew” option on the plan creation page of the customer portal and also enables the “Auto-Rollover Toggle on/off button”  for active plans on the plan module of the customer portal">
                        <FormGroup>
                          <Input name="acceptsRollover" onChange={(e) => handlePropertyCheckBox(e)} type="checkbox" />
                          <label className="form-label">Accept Rollover</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection of this enables the options (Yes/No)  for users to set up the “Allow Liquidation” criteria option on the plan creation page of the customer portal and also enables the “Withdraw” action button for “Active” plans on the plan module of the customer portal.">
                        <FormGroup>
                          <Input name="allowsLiquidation" onChange={(e) => handlePropertyCheckBox(e)} type="checkbox" />
                          <label className="form-label">Allows Liquidation</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection allows Transfer Action to display in the  plan card tile of the created product and property allows user to transfer into their active plans that have interest receipt option as “At Maturity” only.">
                        <FormGroup>
                          <Input name="allowsTransfer" onChange={(e) => handlePropertyCheckBox(e)} type="checkbox" />
                          <label className="form-label">Allows Transfer</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection allows active plans that have interest receipt option as “At Maturity” only be available to receive transfers from other plans">
                        <FormGroup>
                          <Input name="receivesTransfer" onChange={(e) => handlePropertyCheckBox(e)} type="checkbox" />
                          <label className="form-label">Receives Transfer</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection allows active plans that have interest receipt option as “At Maturity” only to be available to receive top-up from external sources (such as their debit card and bank transfers) and also enables the “Top-up” Action button to be displayed for the active plan in the customer portal">
                        <FormGroup>
                          <Input name="allowsTopUp" onChange={(e) => handlePropertyCheckBox(e)} type="checkbox" />
                          <label className="form-label">Allows Top-up</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                  </>

                  <Col md="12">
                    <h6 className="mt-3">Interest Options</h6>
                  </Col>
                  <>
                    <Col md="6">
                      <Tooltip title="This displays “Upfront” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                        <FormGroup>
                          <Input
                            name="hasUpfrontInterestRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Upfront Interest Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="This displays “Monthly” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                        <FormGroup>
                          <Input
                            name="hasMonthlyInterestRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Monthly Interest Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="This displays “Quarterly” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                        <FormGroup>
                          <Input
                            name="hasQuarterlyInterestRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Quarterly Interest Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="This displays “Bi-annually” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                        <FormGroup>
                          <Input
                            name="hasBiAnnualInterestRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Bi-Annual Interest Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="This displays “Maturity” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                        <FormGroup>
                          <Input name="hasMaturityRate" onChange={(e) => handleInterestOptions(e)} type="checkbox" />
                          <label className="form-label">Has Maturity Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                        <FormGroup>
                          <Input
                            name="hasBackendUpfrontInterestRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Backend Upfront Interest Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                        <FormGroup>
                          <Input
                            name="hasBackendMonthlyInterestRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Backend Monthly Interest Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                        <FormGroup>
                          <Input
                            name="hasBackendQuarterlyInterestRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Backend Quarterly Interest Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                        <FormGroup>
                          <Input
                            name="hasBackendBiAnnualInterestRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Backend Bi-Annual Interest Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="6">
                      <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                        <FormGroup>
                          <Input
                            name="hasBackendMaturityRate"
                            onChange={(e) => handleInterestOptions(e)}
                            type="checkbox"
                          />
                          <label className="form-label">Has Backend Maturity Rate</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                  </>

                  <Col md="6">
                    <Tooltip title="This property allows for the type of interest computation to be setup for the plan. The selected formula will be used to compute the interest values for the plan">
                      <FormGroup>
                        <label className="form-label">Select Interest Computation Formula</label>
                        <RSelect
                          options={interestFormula}
                          onChange={(e) => setProperties({ ...properties, interestFormula: e.value })}
                          required
                        />
                      </FormGroup>
                    </Tooltip>
                  </Col>
                  <Col md="6">
                    <Tooltip title="This property allows for the type of penalty computation to be setup for the plan. The selected formula will be used to compute the penal values for the early liquidations before maturity">
                      <FormGroup>
                        <label className="form-label">Select Penalty Computation Formula</label>
                        <RSelect
                          options={computationFormula}
                          onChange={(e) => {
                            setProperties({ ...properties, penaltyFormula: e.value });
                            setAllowSubmit(true);
                          }}
                          required
                        />
                      </FormGroup>
                    </Tooltip>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Product</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Product Name</label>
                      <input
                        type="text"
                        name="productName"
                        placeholder="Product Name"
                        defaultValue={formData.productName}
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.productName && <span className="invalid">{errors.productName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Abbreviation</label>
                      <input
                        type="text"
                        name="productCode"
                        placeholder="Abbreviation"
                        defaultValue={formData.productCode}
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        maxLength="6"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.productCode && <span className="invalid">{errors.productCode.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Category</label>
                      <RSelect
                        defaultValue={
                          productCategoryOptions.filter(({ value }) => value === formData.productCategory)[0]
                        }
                        onChange={(e) => handleSelectChange(e, "productCategory")}
                        placeholder="Please Select A Category"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                        options={productCategoryOptions}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Minimum Transaction Limit</label>
                      <input
                        type="text"
                        name="minTransactionLimit"
                        placeholder="0.00"
                        defaultValue={formData.minTransactionLimit}
                        onChange={(e) => setFormData({ ...formData, minTransactionLimit: parseInt(e.target.value) })}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.minTransactionLimit && (
                        <span className="invalid">{errors.minTransactionLimit.message}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Maximum Transaction Limit</label>
                      <input
                        type="number"
                        name="maxTransactionLimit"
                        placeholder="0.00"
                        defaultValue={formData.maxTransactionLimit}
                        onChange={(e) => setFormData({ ...formData, maxTransactionLimit: parseInt(e.target.value) })}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.maxTransactionLimit && (
                        <span className="invalid">{errors.maxTransactionLimit.message}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        placeholder="Select Status"
                        defaultValue={statusOptions.find((d) => d.value === String(formData.status))}
                        options={statusOptions}
                        onChange={(e) => handleSelectChange(e, "status")}
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Product Description</label>
                      <textarea
                        name="productDescription"
                        defaultValue={formData.productDescription}
                        placeholder="Your description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.productDescription && (
                        <span className="invalid">{errors.productDescription.message}</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col size="4">
                    <div className="">
                      <img src={formData.imageUrl} alt="" style={{ width: "10rem" }} />
                    </div>
                  </Col>
                  <Col size="8">
                    <FormGroup>
                      <label className="form-label">Image</label>
                      <input
                        type="file"
                        name="imageUrl"
                        accept="image/*"
                        placeholder="Product Image"
                        className="form-control"
                        onChange={(e) => encodeImageFileAsURL(e)}
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  {/* <Col md="12">
                    <FormGroup>
                      <label className="form-label">Interest Option</label>
                      <RSelect options={interestOptions}
                        defaultValue={formData.interestOption}  onChange={(e) => setFormData({ ...formData, interestOption: e.value })} />
                    </FormGroup>
                  </Col> */}

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label font-bold">Tenors</label>
                      <RSelect
                        options={tenorOptions}
                        placeholder="Select Tenors"
                        isMulti
                        closeMenuOnSelect={false}
                        defaultValue={formData.tenors}
                        onChange={(e) => handleMultiSelect(e, "tenors")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Currencies</label>
                      <RSelect
                        options={currencyOptions}
                        placeholder="Select Currencies"
                        isMulti
                        closeMenuOnSelect={false}
                        defaultValue={formData?.currency}
                        onChange={(e) => handleMultiSelect(e, "currency")}
                      />
                    </FormGroup>
                  </Col>

                  <br />
                  <br />
                  <Col md="12">
                    <FormGroup>
                      <Input
                        name="allowCustomization"
                        type="checkbox"
                        defaultChecked={formData.allowCustomization}
                        onChange={(e) => setFormData({ ...formData, allowCustomization: e.target.checked })}
                      />
                      <label className="form-label">Allow Tenor Customization</label>
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <h6 className="font-bold text-bold mt-3">Choose Properties</h6>
                  </Col>

                  <>
                    <Col md="4">
                      <Tooltip title="Selection of this will display the target amount field in the plan creation page of the customer portal.">
                        <FormGroup>
                          <Input
                            name="hasTargetAmount"
                            type="checkbox"
                            defaultChecked={properties?.hasTargetAmount}
                            onChange={(e) => handlePropertyCheckBox(e)}
                          />
                          <label className="form-label">Has Target Amount</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                    <Col md="4">
                      <Tooltip title="Selection of this will display the following Frequency options Daily, Weekly, and Monthly to be available for selection during plan creation via the customer portal/admin portal and also display the savings frequency contribution value field and the checkbox to accept contribution value in the plan creation page of the customer portal.">
                        <FormGroup>
                          <Input
                            name="hasSavingFrequency"
                            type="checkbox"
                            defaultChecked={properties?.hasSavingFrequency}
                            onChange={(e) => handlePropertyCheckBox(e)}
                          />
                          <label className="form-label">Has Savings Frequency</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection of this enables the options (Yes/No) to be available for selection during plan creation via the customer portal/admin portal for the user creating a plan to set up the direct mandate. ">
                        <FormGroup>
                          <Input
                            name="hasDirectDebit"
                            onChange={(e) => handlePropertyCheckBox(e)}
                            type="checkbox"
                            defaultChecked={properties?.hasDirectDebit}
                          />
                          <label className="form-label">Has Direct Debit</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection of this enables the “number of tickets'' to display in the plan creation page of the customer portal.">
                        <FormGroup>
                          <Input
                            name="allowsMonthlyDraw"
                            onChange={(e) => handlePropertyCheckBox(e)}
                            type="checkbox"
                            defaultChecked={properties?.allowsMonthlyDraw}
                          />
                          <label className="form-label">Allows Monthly Draw</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection of this enables the options (Yes/No)  for users to set up the “Auto Renew” option on the plan creation page of the customer portal and also enables the “Auto-Rollover Toggle on/off button”  for active plans on the plan module of the customer portal">
                        <FormGroup>
                          <Input
                            name="acceptsRollover"
                            onChange={(e) => handlePropertyCheckBox(e)}
                            type="checkbox"
                            defaultChecked={properties?.acceptsRollover}
                          />
                          <label className="form-label">Accept Rollover</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection of this enables the options (Yes/No)  for users to set up the “Allow Liquidation” criteria option on the plan creation page of the customer portal and also enables the “Withdraw” action button for “Active” plans on the plan module of the customer portal.">
                        <FormGroup>
                          <Input
                            name="allowsLiquidation"
                            onChange={(e) => handlePropertyCheckBox(e)}
                            type="checkbox"
                            defaultChecked={properties?.allowsLiquidation}
                          />
                          <label className="form-label">Allows Liquidation</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection allows Transfer Action to display in the  plan card tile of the created product and property allows user to transfer into their active plans that have interest receipt option as “At Maturity” only.">
                        <FormGroup>
                          <Input
                            name="allowsTransfer"
                            onChange={(e) => handlePropertyCheckBox(e)}
                            type="checkbox"
                            defaultChecked={properties?.allowsTransfer}
                          />
                          <label className="form-label">Allows Transfer</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection allows active plans that have interest receipt option as “At Maturity” only be available to receive transfers from other plans">
                        <FormGroup>
                          <Input
                            name="receivesTransfer"
                            onChange={(e) => handlePropertyCheckBox(e)}
                            type="checkbox"
                            defaultChecked={properties?.receivesTransfer}
                          />
                          <label className="form-label">Receives Transfer</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>

                    <Col md="4">
                      <Tooltip title="Selection allows active plans that have interest receipt option as “At Maturity” only to be available to receive top-up from external sources (such as their debit card and bank transfers) and also enables the “Top-up” Action button to be displayed for the active plan in the customer portal">
                        <FormGroup>
                          <Input
                            name="allowsTopUp"
                            onChange={(e) => handlePropertyCheckBox(e)}
                            type="checkbox"
                            defaultChecked={properties?.allowsTopUp}
                          />
                          <label className="form-label">Allows Top-up</label>
                        </FormGroup>
                      </Tooltip>
                    </Col>
                  </>

                  {/* <Col md="12">
                    <FormGroup>
                      <label className="form-label">Tenor Display</label>
                      <Select
                        className="form-control"
                        name='currency'
                        onChange={(e) => setFormData({ ...formData, tenorDisplayIn: e })}
                        defaultValue={formData.tenorDisplayIn}
                        placeholder="Tenor Display In"
                      >
                            <Option value="IN_DAYS">Display Tenor In Days</Option>
                            <Option value="IN_MONTHS">Display Tenor In Months</Option>
                            <Option value="IN_YEARS">Display Tenor In Years</Option>
                      </Select>
                    </FormGroup>
                  </Col> */}

                  <Col md="12">
                    <h6 className="mt-3">Interest Options</h6>
                  </Col>
                  {interestOption ? (
                    <>
                      <Col md="6">
                        <Tooltip title="This displays “Upfront” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                          <FormGroup>
                            <Input
                              name="hasUpfrontInterestRate"
                              defaultChecked={interestOption.hasUpfrontInterestRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Upfront Interest Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="This displays “Monthly” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                          <FormGroup>
                            <Input
                              name="hasMonthlyInterestRate"
                              defaultChecked={interestOption.hasMonthlyInterestRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Monthly Interest Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="This displays “Quarterly” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                          <FormGroup>
                            <Input
                              name="hasQuarterlyInterestRate"
                              defaultChecked={interestOption.hasQuarterlyInterestRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Quarterly Interest Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="This displays “Bi-annually” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                          <FormGroup>
                            <Input
                              name="hasBiAnnualInterestRate"
                              defaultChecked={interestOption.hasBiAnnualInterestRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Bi-Annual Interest Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="This displays “Maturity” on the interest receipt selection list. The rate set up for this will be displayed as calculated interest rate if option is selected">
                          <FormGroup>
                            <Input
                              name="hasMaturityRate"
                              defaultChecked={interestOption.hasMaturityRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Maturity Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                          <FormGroup>
                            <Input
                              name="hasBackendUpfrontInterestRate"
                              defaultChecked={interestOption.hasBackendUpfrontInterestRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Backend Upfront Interest Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                          <FormGroup>
                            <Input
                              name="hasBackendMonthlyInterestRate"
                              defaultChecked={interestOption.hasBackendMonthlyInterestRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Backend Monthly Interest Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                          <FormGroup>
                            <Input
                              name="hasBackendQuarterlyInterestRate"
                              defaultChecked={interestOption.hasBackendQuarterlyInterestRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Backend Quarterly Interest Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                          <FormGroup>
                            <Input
                              name="hasBackendBiAnnualInterestRate"
                              defaultChecked={interestOption.hasBackendBiAnnualInterestRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Backend Bi-Annual Interest Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                      <Col md="6">
                        <Tooltip title="The rate set up for this will be used to benchmark the extended rate inputted during plan creation from the admin portal for this option. Rates inputted cannot be above the rate set">
                          <FormGroup>
                            <Input
                              name="hasBackendMaturityRate"
                              defaultChecked={interestOption.hasBackendMaturityRate}
                              onChange={(e) => handleInterestOptions(e)}
                              type="checkbox"
                            />
                            <label className="form-label">Has Backend Maturity Rate</label>
                          </FormGroup>
                        </Tooltip>
                      </Col>
                    </>
                  ) : null}

                  <Col md="6">
                    <Tooltip title="This property allows for the type of interest computation to be setup for the plan. The selected formula will be used to compute the interest values for the plan">
                      <FormGroup>
                        <label className="form-label">Select Interest Computation Formula</label>
                        <RSelect
                          defaultValue={interestFormula.find((d) => d.value === String(properties?.interestFormula))}
                          options={interestFormula}
                          onChange={(e) => setProperties({ ...properties, interestFormula: e.value })}
                        />
                      </FormGroup>
                    </Tooltip>
                  </Col>
                  <Col md="6">
                    <Tooltip title="This property allows for the type of penalty computation to be setup for the plan. The selected formula will be used to compute the penal values for the early liquidations before maturity">
                      <FormGroup>
                        <label className="form-label">Select Penalty Computation Formula</label>
                        <RSelect
                          defaultValue={computationFormula.find((d) => d.value === String(properties?.penaltyFormula))}
                          options={computationFormula}
                          onChange={(e) => setProperties({ ...properties, penaltyFormula: e.value })}
                        />
                      </FormGroup>
                    </Tooltip>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">View Product</h5>
              {details ? (
                <div className="mt-4">
                  <div className="mb-4">
                    <img
                      style={{
                        width: "15rem",
                      }}
                      src={details.imageUrl}
                      alt={details.productName}
                    />
                  </div>
                  <div className="pb-4">
                    <h5>Product Name</h5>
                    <p className="p-0 m-0">{details.productName}</p>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="p-0 m-0">
                        Maximum Transaction: <span>{details.maxTransactionLimit}</span>
                      </p>
                    </div>
                    <div>
                      <p className="p-0 m-0">
                        Minimum Transaction: <span>{details.minTransactionLimit}</span>
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 mb-4">
                    <div>
                      <p className="p-0 m-0">Product Description</p>
                    </div>
                    <div>
                      <p className="p-0 m-0">{details.productDescription}</p>
                    </div>
                  </div>
                  <div className="mb-4 d-flex justify-content-between align-items-center">
                    <div>
                      <p className="p-0 m-0">
                        {details.tenors ? (
                          <>
                            Tenor:{" "}
                            <span>
                              {details.tenors.map((tenor) => (
                                <span>{tenor.tenorName + ", "}</span>
                              ))}
                            </span>
                          </>
                        ) : null}
                      </p>
                    </div>
                    <p className="p-0 m-0">
                      {details.currency ? (
                        <>
                          Currency:{" "}
                          <span>
                            {details.currency.map((cur) => (
                              <span>{cur.name + ", "}</span>
                            ))}
                          </span>
                        </>
                      ) : null}
                    </p>
                  </div>
                  <h5 className="mb-2">Properties</h5>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="p-0 m-0">
                        Accepts Rollover:{" "}
                        <span>
                          {details ? <>{details.properties?.acceptsRollover === true ? <>Yes</> : <>No</>} </> : null}
                        </span>
                      </p>
                    </div>
                    <div>
                      <p className="p-0 m-0">
                        Allows Liquidation:{" "}
                        <span>
                          {details ? <>{details.properties?.allowsLiquidation === true ? <>Yes</> : <>No</>} </> : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Allows Monthly Draw:{" "}
                      <span>
                        {details ? <>{details.properties?.allowsMonthlyDraw === true ? <>Yes</> : <>No</>} </> : null}
                      </span>
                    </p>
                    <div>
                      <p className="p-0 m-0">
                        Allows TopUp:{" "}
                        <span>
                          {details ? <>{details?.properties?.allowsTopUp === true ? <>Yes</> : <>No</>} </> : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Allows Transfer:{" "}
                      <span>
                        {details ? <>{details?.properties?.allowsTransfer === true ? <>Yes</> : <>No</>} </> : null}
                      </span>
                    </p>
                    <div>
                      <p className="p-0 m-0">
                        Receives Transfer:{" "}
                        <span>
                          {details ? <>{details?.properties?.receivesTransfer === true ? <>Yes</> : <>No</>} </> : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Has Direct Debit:{" "}
                      <span>
                        {details ? <>{details?.properties?.hasDirectDebit === true ? <>Yes</> : <>No</>} </> : null}
                      </span>
                    </p>
                    <div>
                      <p className="p-0 m-0">
                        Has Saving Frequency:{" "}
                        <span>
                          {details ? (
                            <>{details?.properties?.hasSavingFrequency === true ? <>Yes</> : <>No</>} </>
                          ) : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Has Target Amount:{" "}
                      <span>
                        {details ? <>{details?.properties?.hasTargetAmount === true ? <>Yes</> : <>No</>} </> : null}
                      </span>
                    </p>
                  </div>
                  <h5 className="mt-4 mb-2">Interest Options</h5>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Has Backend BiAnnual Interest Rate:{" "}
                      <span>
                        {details ? (
                          <>
                            {details?.properties?.interestOptions.hasBackendBiAnnualInterestRate === true ? (
                              <>Yes</>
                            ) : (
                              <>No</>
                            )}{" "}
                          </>
                        ) : null}
                      </span>
                    </p>
                    <div>
                      <p className="p-0 m-0">
                        Has Backend Maturity Rate:{" "}
                        <span>
                          {details ? (
                            <>
                              {details.properties?.interestOptions.hasBackendMaturityRate === true ? <>Yes</> : <>No</>}{" "}
                            </>
                          ) : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Has Backend Monthly Interest Rate:{" "}
                      <span>
                        {details ? (
                          <>
                            {details.properties?.interestOptions.hasBackendMonthlyInterestRate === true ? (
                              <>Yes</>
                            ) : (
                              <>No</>
                            )}{" "}
                          </>
                        ) : null}
                      </span>
                    </p>
                    <div>
                      <p className="p-0 m-0">
                        Has Backend Quarterly Interest Rate:{" "}
                        <span>
                          {details ? (
                            <>
                              {details.properties?.interestOptions.hasBackendQuarterlyInterestRate === true ? (
                                <>Yes</>
                              ) : (
                                <>No</>
                              )}{" "}
                            </>
                          ) : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Has Backend Upfront Interest Rate:{" "}
                      <span>
                        {details ? (
                          <>
                            {details.properties?.interestOptions.hasBackendUpfrontInterestRate === true ? (
                              <>Yes</>
                            ) : (
                              <>No</>
                            )}{" "}
                          </>
                        ) : null}
                      </span>
                    </p>
                    <div>
                      <p className="p-0 m-0">
                        Has BiAnnual Interest Rate:{" "}
                        <span>
                          {details ? (
                            <>
                              {details.properties?.interestOptions.hasBiAnnualInterestRate === true ? (
                                <>Yes</>
                              ) : (
                                <>No</>
                              )}{" "}
                            </>
                          ) : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Has Maturity Rate:{" "}
                      <span>
                        {details ? (
                          <>{details.properties?.interestOptions.hasMaturityRate === true ? <>Yes</> : <>No</>} </>
                        ) : null}
                      </span>
                    </p>
                    <div>
                      <p className="p-0 m-0">
                        Has Monthly Interest Rate:{" "}
                        <span>
                          {details ? (
                            <>
                              {details.properties?.interestOptions.hasMonthlyInterestRate === true ? <>Yes</> : <>No</>}{" "}
                            </>
                          ) : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="p-0 m-0">
                      Has Quarterly Interest Rate:{" "}
                      <span>
                        {details ? (
                          <>
                            {details.properties?.interestOptions.hasQuarterlyInterestRate === true ? <>Yes</> : <>No</>}{" "}
                          </>
                        ) : null}
                      </span>
                    </p>
                    <div>
                      <p className="p-0 m-0">
                        Has Upfront Interest Rate:{" "}
                        <span>
                          {details ? (
                            <>
                              {details.properties?.interestOptions.hasUpfrontInterestRate === true ? <>Yes</> : <>No</>}{" "}
                            </>
                          ) : null}
                        </span>
                      </p>
                    </div>
                  </div>
                  <p className="p-0 m-0 mt-2">
                    Penalty Computational Formula:{" "}
                    <span>{details ? <>{details.properties?.penaltyFormula}</> : null}</span>
                  </p>
                  <p className="p-0 m-0">
                    Interest Formula: <span>{details ? <>{details.properties?.interestFormula}</> : null}</span>
                  </p>
                </div>
              ) : null}
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
